{
  "slug": "iq-vs-gpa",
  "title": "IQ vs GPA",
  "description": "IQ is normed test performance; GPA reflects grades, effort, opportunity, coursework, and school context.",
  "category": "Comparisons",
  "sections": [
    {
      "heading": "Purpose",
      "paragraphs": [
        "IQ is normed test performance; GPA reflects grades, effort, opportunity, coursework, and school context.",
        "Begin with purpose rather than asking which score is universally better."
      ]
    },
    {
      "heading": "Measurement differences",
      "paragraphs": [
        "Compare content, limits, norms, reliability, validity, preparation, and decision rules.",
        "Correlation does not make measures interchangeable."
      ]
    },
    {
      "heading": "What to use",
      "paragraphs": [
        "Use evidence validated for the question. Admissions, clinical evaluation, grades, creativity, and emotion need different evidence.",
        "Do not convert scores without a justified publisher method."
      ]
    }
  ],
  "related": ["iq-vs-intelligence", "iq-vs-eq", "how-is-iq-measured"],
  "sources": [],
  "faqs": [],
  "summary": "IQ is normed test performance; GPA reflects grades, effort, opportunity, coursework, and school context. Content reviewed 18 July 2026."
}
